import { map } from "rxjs";
import { AccountInformation } from "../model/AccountInformation";
import { apiService } from "./ApiService";

const getAccountInfo = () => {
  return apiService
    .get<{ account: AccountInformation }>({
      path: `public/account/infos`,
      requiresAuthPolicy: "user",
      crm: true,
    })
    .pipe(map(({ account }) => account));
};
export { getAccountInfo };
